<template>
	<div id="spye">
		<NavigationBar />

		<Breadcrumb :productName="Breadcrumb.productName" />

		<MainBannerProduct :productName = "banner.productName" 
			:tagline = "banner.tagline" 
			:features = "banner.features" 
			:directLink = "banner.link" 
			:img = "banner.img"
			:posTop = "banner.posTop"
			:posBottom = "banner.posBottom"
			:imageScale = "banner.imageScale"
			:price="banner.price" />

		<DownloadBanner />

		<div class="uk-section uk-background-muted uk-padding-remove-bottom">
			<div class="uk-container uk-container-expand uk-padding-remove">
				<div class="uk-flex uk-flex-center uk-flex-stretch uk-cover-container" uk-grid>
					<div class="uk-width-1-1">
						<img src="../assets/Asset 2@2x.png" alt="../Asset 2@2x.png" width="100%" uk-img>
					</div>
				</div>
			</div>
		</div>

		<div class="uk-section">
			<div class="uk-container uk-container-expand">
				<div class="uk-flex uk-flex-center" uk-grid>
					<div class="uk-width-1-1">
						<h3 class="uk-text-uppercase uk-text-center">powerfull night vision</h3>
						<VueCompareImage :leftImage="` ${ require('../assets/brown-wooden-center-table-584399DAY.jpg') } `" 
											:rightImage="` ${ require('../assets/brown-wooden-center-table-584399NIGHT.jpg') } `"
											:sliderLineWidth="0"
											style="" />
					</div>
				</div>
			</div>
		</div>

		<ProductSpesification :productName = "banner.productName"
								:description = "productSpesification.description"
								:features = "productSpesification.features"
								:link = "productSpesification.link"
								:img = "productSpesification.img"
								:imgScale = "productSpesification.imgScale"
								:imgPositionX = "productSpesification.imgPositionX"
								:imgPositionY = "productSpesification.imgPositionY"
								:spesification = "productSpesification.spesification" />
		
		<div class="uk-section uk-padding-remove">
			<hr>
		</div>

		<!-- <div class="uk-section">
			<div class="uk-container">
				<div class="uk-flex uk-flex-middle uk-margin-remove-left" uk-grid>
					<router-link to="" class="uk-button uk-button-primary uk-margin-auto" style="border-radius: 10px;x">
						<h3 class="uk-text-uppercase" style="color: rgb(255, 255, 255); padding: 1vw;">buy now</h3>
					</router-link>
				</div>
			</div>
		</div> -->

		<Footer />
	</div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Footer from '@/components/Footer.vue'
import MainBannerProduct from '@/components/MainBannerProduct.vue'
import DownloadBanner from '@/components/DownloadBanner.vue'
import VueCompareImage from 'vue-compare-image'
import ProductSpesification	from '@/components/ProductSpesification.vue'

export default {
	name: 'spye',
	components: {
		NavigationBar,
		Breadcrumb,
		MainBannerProduct,
		DownloadBanner,
		VueCompareImage,
		ProductSpesification,
		Footer
	},
	data () {
		return {
			Breadcrumb: {
				productName: 'spye'
			},
			banner: {
				productName: 'spye',
				tagline: 'keeping your family safe',
				features: ['security', 'remote monitor', 'app control', '2 way mic'],
				link: 'https://youtu.be/X-p20C2mugs',
				img: require('../assets/spye-banner-1.png'),
				posTop: '-5px',
				posBottom: '-135px',
				imageScale: 'scale(1.25)',
				price: '',
			},
			productSpesification: {
				description: 'Flexible viewing anywhere you are with remote adjustment',
				features: [
					'HD Camera with 1080p Resolution.',
					'Motion Detection with Adjustable Alert System.',
					'Clear Day and Night Vision.',
					'Captures Sound with Two Way Audio System.',
					'App Connectivity on iOS & Android devices.',
					'Support Local SD Card Slot up to 128GB.',
					'Cloud Storage Availability.',
					'Support 24 Hour Continious Recording.',
					'Remote Adjustment for Flexible 360\xB0 Viewing.'
				],
				price: 'Rp. 123.500,00 include gst',
				link: '',
				img: require('../assets/oie_qJ0LzuLRQVTi.png'),
				imgScale: 'scale(1.1)',
				imgPositionX: 'left bottom',
				imgPositionY: '60',
				spesification: [
					{
						title: 'Model',
						subtitle: 'SPYE'
					},
					{
						title: 'Dimension',
						subtitle: ['64 x 96mm']
					},
					{
						title: 'Weight',
						subtitle: '170g'
					},
					{
						title: 'Color',
						subtitle: 'White'
					},
					{
						title: 'Connectivity',
						subtitle: ['2.4GHz WiFi router','Doesn\u2019t support the 5GHz']
					},
					{
						title: 'Connectivity Security',
						subtitle: ['WPA-PSK/WPA2-PSK']
					},
					{
						title: 'Connectivity Range',
						subtitle: '10m'
					},
					{
						title: 'Video Quality',
						subtitle: 'HD 1080'
					},
					{
						title: 'Frame Rate',
						subtitle: '1~25 per second'
					},
					{
						title: 'Pixel',
						subtitle: '2mb'
					},
					{
						title: 'Audio',
						subtitle: ['Two-way Audio']
					},

					{
						title: 'Storage ',
						subtitle: 'Cloud Storage + SD Card Max 128GB (not included in package)'
					},
					{
						title: 'Control ',
						subtitle: ['Roomi App (Android & iOS) -- kasih link utk download appnya']
					},
					{
						title: 'Power Usage',
						subtitle: 'DC5V, 1A; 4.5W Max'
					},
					{
						title: 'Rotation',
						subtitle: 'App Control: Tilt: -10º ~ 75º '
					},
					{
						title: 'Includes',
						subtitle: 'USB Power Adaptor, USB Cable, Bracket, Screws, Reset Pin, Manual Book, Adhesive Tape'
					},
				]
			}
		}
	},
	mounted () {
		
	},
	methods: {
		
	}
}
</script>

<style>

</style>